import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { options } from '@options';
import { IconComponent } from '@library';
import { LogoComponent } from '../logo/logo.component';

@Component({
    selector: 'app-box',
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, LogoComponent, IconComponent],
})
export class BoxComponent {
    private router = inject(Router);
    readonly activatedRoute = inject(ActivatedRoute);

    readonly logoSrc = options.logoSrc.dark;

    @Input() type: 'logo' | 'back' = 'logo';
    @Input() title?: string;

    onCloseClick() {
        this.router.navigate([{ outlets: { mobile: null } }]);
    }
}
